import diff from 'deep-diff';
import { keyGen } from './keygen';

const subjects = new Map();

const tryParse  = json => {
    try {
        return JSON.parse(json);
    }
    catch (error) {
        console.log('dbx parse error:', json, error);
        return undefined;
    }
}

const getSubject = topic => {
    const sessionState = sessionStorage.getItem(topic);
    
    if (!subjects.has(topic)) {
        if (sessionState !== undefined && sessionState !== 'undefined') {
            subjects.set(topic, {state: tryParse(sessionState), subscribers: new Map()});        
        }
        else {
            subjects.set(topic, {state: undefined, subscribers: new Map()});        
        }
    }

    return subjects.get(topic);
}

const load = data => {
    if (!data || data.size === 0) throw new Error('Invalid Argument');
    // eslint-disable-next-line no-unused-expressions
    data?.forEach((value, topic) => {
        getSubject(topic).state = value;
    });
}

const subscribe = ({topic, hook}) => {
    const id = keyGen(5);

    getSubject(topic).subscribers.set(id, hook);


    return () => unsubscribe({id, topic});
}

const broadcast = subject => {
    subject.subscribers.forEach(hook => {
        hook(subject.state);
    });
}

const clone = subject => {
    return subject ? tryParse(JSON.stringify(subject)) : undefined;
}

const publish = ({topic, value, durable = true, forceBroadcast = false}) => {
    const subject = getSubject(topic);

    if (forceBroadcast || diff(subject.state, value)) {
        subject.state = clone(value);
        if (durable) {
            sessionStorage.setItem(topic, JSON.stringify(value));
        }
        broadcast(subject);
    }
}

const read = topic => {
    const state = getSubject(topic).state;
    
    if (state === undefined || state === null || state === 'undefined') return undefined;
    
    //console.log(topic, state, typeof state)

    return typeof state === 'object' ? clone(state) : state;
}

const clear = () => {
    subjects.clear();
}

const unsubscribe = ({id, topic}) => {
    // console.log('cache unsubscribe', id, topic);
    getSubject(topic).subscribers.delete(id)
};

const has = topic => subjects.has(topic);

const write = ({topic, fragment}) => {
    const state = getSubject(topic).state || {};

    publish({
        topic,
        value: {...state, ...fragment}
    });

    console.log('dbx write', topic, fragment, {...state, ...fragment})
}

const Dbx = {
    clear,
    load,
    publish,
    subscribe,
    unsubscribe,
    read,
    has,
    write
}

export {Dbx}